import { CSSObject } from "@emotion/react";

export const filtersBlockStyle = (hideSearch?: boolean) => {
    return {
        "@media(max-width: 839px)": {
            flex: hideSearch ? "0.5" : "1"
        },

        "@media(max-width: 599px)": {
            flex: hideSearch ? "1" : "unset",
            marginLeft: hideSearch ? "0" : "8px"
        }
    };
};

export const tableColumnDropShadow = (
    scrollHorizontal: boolean | undefined
) => {
    return {
        filter: scrollHorizontal
            ? `drop-shadow(-6px 0px 7px rgba(15, 23, 42, 0.08))`
            : "unset",
        transition: `filter 0.5s ease-in`
    };
};

export const tableColumnRightDropShadow = (
    scrollHorizontal: boolean | undefined
) => {
    return {
        filter: scrollHorizontal
            ? `drop-shadow(6px 0px 7px rgba(15, 23, 42, 0.08))`
            : "unset",
        transition: `filter 0.5s ease-in`
    };
};

export const svgFontSize = (size: number): CSSObject => ({
    width: `${size}px`,
    height: `${size}px`
});
